import React, { useState, useEffect } from "react";
import "./App.css";

import { Route, Switch, Redirect, NavLink } from "react-router-dom";

import AuthContext from "./auth/context";

import Login from "./screens/Login";
import TopNavBar from "./components/topNavBar";
import DashBoard from "./components/DashBoard";
import Utilisateurs from "./screens/Utilisateurs";
import Salaries from "./screens/Salaries";
import Clients from "./screens/Clients";
import Missions from "./screens/Missions";
import PushNotification from "./components/PushNotification";

function App() {
  const [initDone, setInitDone] = useState(false);
  const [user, setUser] = useState();

  useEffect(() => {
    const userDataLocal = localStorage.getItem("currentUser");
    if (userDataLocal) {
      setUser(JSON.parse(userDataLocal));
    }

    setInitDone(true);
  }, []);

  if (!initDone) return null;

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      {!user && <Login />}
      {user && (
        <div className="wrapper">
          <div className="left-side-menu">
            <a href="index.html" className="logo text-center logo-light">
              <span className="logo-lg">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/logo_horizontal.png"
                  }
                  alt=""
                  height="48"
                />
              </span>
              <span className="logo-sm">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/picto.png"}
                  alt=""
                  height="32"
                />
              </span>
            </a>

            <a href="index.html" className="logo text-center logo-dark">
              <span className="logo-lg">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/logo_horizontal.png"
                  }
                  alt=""
                  height="48"
                />
              </span>
              <span className="logo-sm">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/picto.png"}
                  alt=""
                  height="32"
                />
              </span>
            </a>

            <div className="h-100" id="left-side-menu-container" data-simplebar>
              <ul className="metismenu side-nav">
                <li className="side-nav-title side-nav-item">Navigation</li>

                <li className="side-nav-item">
                  <NavLink exact to="/" className="side-nav-link">
                    <i className="uil-home-alt"></i>
                    <span> Dashboards </span>
                  </NavLink>
                </li>
                <li className="side-nav-title side-nav-item">référentiels</li>
                <li className="side-nav-item">
                  <NavLink to="/salaries" className="side-nav-link">
                    <i className="uil uil-users-alt"></i>
                    <span> Salariés </span>
                  </NavLink>
                </li>
                <li className="side-nav-item">
                  <NavLink to="/clients" className="side-nav-link">
                    <i className="uil uil-users-alt"></i>
                    <span> Clients </span>
                  </NavLink>
                </li>
                <li className="side-nav-title side-nav-item">Données</li>
                <li className="side-nav-item">
                  <NavLink to="/missions" className="side-nav-link">
                    <i className="uil uil-clock-seven"></i>
                    <span> Missions </span>
                  </NavLink>
                </li>
                {user.profil === "ADMIN" && (
                  <>
                    <li className="side-nav-title side-nav-item">Admin</li>
                    <li className="side-nav-item">
                      <NavLink to="/users" className="side-nav-link">
                        <i className="uil uil-book-reader"></i>
                        <span> Utilisateurs </span>
                      </NavLink>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </div>

          <div className="content-page">
            <div className="content">
              <TopNavBar />

              <div className="container-fluid">
                <Switch>
                  <Route path="/missions" component={Missions} />
                  <Route path="/clients" component={Clients} />
                  <Route path="/salaries" component={Salaries} />
                  <Route path="/users" component={Utilisateurs} />
                  <Route path="/" component={DashBoard} />

                  <Redirect to="/not-found" />
                </Switch>
              </div>
            </div>
            <footer className="footer">
              <div className="container-fluid">
                <PushNotification />
                <div className="row">
                  <div className="col-md-6">2020 © Senef Soft</div>
                  <div className="col-md-6">
                    <div className="text-md-right footer-links d-none d-md-block"></div>
                  </div>
                </div>
              </div>
            </footer>
          </div>
        </div>
      )}
    </AuthContext.Provider>
  );
}

export default App;
